import React from 'react';
import classNames from 'classnames';
import styles from './StatusDot.module.scss';

export const StatusDotComponent = ({
  status = 'inactive',
  color,
  className,
}) => {
  return (
    <span
      className={classNames(
        styles.statusDot,
        { [styles[`statusDot_${status}`]]: !color },
        className
      )}
      style={color ? { background: `var(--${color})` } : undefined}
    />
  );
};

StatusDotComponent.displayName = 'StatusDot';
